import { loadGsap } from '@/utils/gsap';

function CookieBanner({}) {
	async function onCookiesLoaded() {
		const cookieBanner = document.querySelector('[data-cookie]');
		const hero = document.querySelector('[data-hero]');

		try {
			const { ScrollTrigger } = await loadGsap();

			if (hero) {
				ScrollTrigger.create({
					trigger: hero,
					start: 'bottom 50%',
					once: true,
					onEnter: () => {
						cookieBanner.classList.add('show');
					},
				});
			} else {
				cookieBanner.classList.add('show');
			}
		} catch (error) {
			console.error('CookieBanner: Failed to load dependencies', error);
			if (cookieBanner) cookieBanner.classList.add('show');
		}

		document.removeEventListener('mudCookiesLoaded', onCookiesLoaded);
	}

	document.addEventListener('mudCookiesLoaded', onCookiesLoaded);

	return () => {
		document.removeEventListener('mudCookiesLoaded', onCookiesLoaded);
	};
}

export default CookieBanner;
